import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../NavBar/Navbar';
import ModalUpdateCupon from './Modals/ModalUpdateCupon';
import ModalCreateCupon from './Modals/ModalCreateCupon';
import QRCodeModal from '../Modal/QRCodeModal';
import CuponDetailModal from './Modals/ModalDetailCupons';
import { CouponPosFetchAPI } from '../../api/Coupon';
import { CombosFetchAPI } from '../../api/Combos';
import { GroupsFechtAPI } from '../../api/Groups';
import { CategoriesDashFetchAPI } from '../../api/CategoriesDash';
import defaultImage from "../../assets/img/default.png";
import Footer from '../Footer/Footer';
import ErrorAlert from '../Alerts/ErrorAlert';
import { buildCloudinaryImageUrl } from '../utils/CloudinaryImageUrl';
import AppShell from '../../page/AppShell/AppShell';
import MainContent from '../MainContent/MainContent';

/* ─────────────────────────────────────────────────────────
   CSS — inyectado una vez. Prefijo: .cup-
───────────────────────────────────────────────────────── */
const CUP_CSS = `
@keyframes cup-up   { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
@keyframes cup-fade { from{opacity:0} to{opacity:1} }

/* ── page ── */
.cup-page {
  min-height: 100vh;
  background: var(--bg-3, #F8F8F8);
  padding: 1.5rem clamp(1rem,3vw,2rem) 4rem;
}

/* ── banner ── */
.cup-banner {
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: 1rem;
  background: var(--bg, #fff);
  border: 1.5px solid var(--border, rgba(0,0,0,.07));
  border-radius: 16px;
  padding: 1.1rem 1.35rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 10px rgba(0,0,0,.04);
  animation: cup-up .3s ease both;
}
.cup-banner-eyebrow {
  font-size: .68rem; font-weight: 700;
  letter-spacing: .09em; text-transform: uppercase;
  color: #1B3A6B; margin-bottom: .22rem;
}
.cup-banner-title {
  font-size: 1.15rem; font-weight: 700;
  color: var(--text, #0A0A0A);
  font-family: var(--font-sans, -apple-system, sans-serif);
  letter-spacing: -.02em;
}
.cup-banner-sub { font-size: .77rem; color: var(--text-3, #B4B4B4); margin-top: .18rem; }

/* ── toolbar ── */
.cup-toolbar {
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: .75rem;
  margin-bottom: 1.1rem;
}
.cup-toolbar-left {
  display: flex; align-items: center; gap: .75rem; flex-wrap: wrap;
}
.cup-section-title {
  font-size: .88rem; font-weight: 700;
  color: var(--text, #0A0A0A);
  font-family: var(--font-sans, -apple-system, sans-serif);
  display: flex; align-items: center; gap: .4rem;
}
.cup-count {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 20px; height: 18px; border-radius: 5px;
  background: rgba(27,58,107,.09); color: #1B3A6B;
  font-size: .65rem; font-weight: 700; padding: 0 .35rem;
}

/* ── search ── */
.cup-search {
  display: flex; align-items: center; gap: .45rem;
  padding: .4rem .8rem;
  border: 1.5px solid var(--border-md, rgba(0,0,0,.11));
  border-radius: 999px;
  background: var(--bg, #fff);
  transition: border-color .14s, box-shadow .14s;
}
.cup-search:focus-within {
  border-color: #1B3A6B;
  box-shadow: 0 0 0 3px rgba(27,58,107,.10);
}
.cup-search svg { color: var(--text-3, #B4B4B4); flex-shrink: 0; }
.cup-search input {
  border: none; background: transparent; outline: none;
  font-size: .81rem; color: var(--text, #0A0A0A);
  font-family: var(--font-sans, -apple-system, sans-serif);
  width: 165px;
}
.cup-search input::placeholder { color: var(--text-3, #B4B4B4); }

/* ── grid ── */
.cup-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 1rem;
  animation: cup-up .28s ease both;
}
@media(max-width: 480px) { .cup-grid { grid-template-columns: 1fr; } }

/* ── coupon card ── */
.cup-card {
  background: var(--bg, #fff);
  border: 1.5px solid var(--border, rgba(0,0,0,.07));
  border-radius: 16px;
  overflow: hidden;
  display: flex; flex-direction: column;
  transition: box-shadow .15s, border-color .15s, transform .15s;
  animation: cup-up .22s ease both;
  position: relative;
}
.cup-card:hover {
  box-shadow: 0 6px 22px rgba(0,0,0,.09);
  border-color: rgba(27,58,107,.2);
  transform: translateY(-2px);
}

/* accent stripe top */
.cup-card::before {
  content: ''; display: block; height: 3px;
  background: #1B3A6B; flex-shrink: 0;
}

/* card inner */
.cup-card-inner {
  display: flex; align-items: flex-start; gap: .75rem;
  padding: .85rem .9rem .7rem;
  flex: 1;
}

.cup-thumb {
  width: 56px; height: 56px; border-radius: 10px;
  object-fit: cover; flex-shrink: 0;
  border: 1px solid var(--border, rgba(0,0,0,.07));
  background: var(--bg-2, rgba(0,0,0,.04));
}

.cup-card-body { flex: 1; min-width: 0; }
.cup-card-name {
  font-size: .85rem; font-weight: 700;
  color: var(--text, #0A0A0A);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  margin-bottom: .18rem;
}
.cup-card-desc {
  font-size: .74rem; color: var(--text-3, #B4B4B4);
  line-height: 1.5;
  display: -webkit-box; -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; overflow: hidden;
}

/* card footer actions */
.cup-card-footer {
  display: flex; align-items: center; gap: .25rem;
  padding: .55rem .9rem .75rem;
  border-top: 1px solid var(--border, rgba(0,0,0,.06));
}
.cup-btn {
  display: inline-flex; align-items: center; justify-content: center;
  width: 30px; height: 30px; border-radius: 8px; border: none;
  background: transparent; color: var(--text-3, #B4B4B4);
  font-size: .9rem; cursor: pointer;
  transition: background .13s, color .13s;
}
.cup-btn:hover         { background: rgba(27,58,107,.09); color: #1B3A6B; }
.cup-btn.cup-btn-danger:hover { background: rgba(239,68,68,.08); color: #EF4444; }

.cup-btn-label {
  font-size: .68rem; color: var(--text-3, #B4B4B4);
  white-space: nowrap;
}

/* ── empty ── */
.cup-empty {
  display: flex; flex-direction: column; align-items: center;
  padding: 3.5rem 1rem; text-align: center;
  grid-column: 1 / -1;
  animation: cup-up .3s ease both;
}
.cup-empty-icon {
  width: 60px; height: 60px; border-radius: 50%;
  background: var(--bg-2, rgba(0,0,0,.04));
  border: 1.5px solid var(--border, rgba(0,0,0,.07));
  display: grid; place-items: center;
  font-size: 1.5rem; margin-bottom: .75rem;
}
.cup-empty-title { font-size: .88rem; font-weight: 600; color: var(--text, #0A0A0A); margin: 0 0 .25rem; }
.cup-empty-sub   { font-size: .76rem; color: var(--text-3, #B4B4B4); margin: 0; }

/* ── pagination ── */
.cup-pagination {
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: .75rem;
  margin-top: 1.25rem;
}
.cup-pag-info { font-size: .75rem; color: var(--text-3, #B4B4B4); font-family: var(--font-sans, -apple-system, sans-serif); }
.cup-pag-info span { color: var(--text-2, #6B6B6B); font-weight: 600; }
.cup-pag-right { display: flex; align-items: center; gap: .55rem; flex-wrap: wrap; }

.cup-pag-size {
  display: inline-flex; align-items: center; gap: .32rem;
  font-size: .73rem; color: var(--text-2, #6B6B6B);
  font-family: var(--font-sans, -apple-system, sans-serif);
}
.cup-pag-size select {
  padding: .24rem .48rem;
  border: 1.5px solid var(--border-md, rgba(0,0,0,.11));
  border-radius: 7px; background: var(--bg, #fff);
  color: var(--text, #0A0A0A);
  font-family: var(--font-sans, -apple-system, sans-serif);
  font-size: .73rem; font-weight: 600; outline: none; cursor: pointer;
  transition: border-color .14s;
}
.cup-pag-size select:focus { border-color: #1B3A6B; }

.cup-pag-controls { display: flex; align-items: center; gap: .28rem; }
.cup-pg-btn {
  width: 28px; height: 28px; border-radius: 7px;
  border: 1.5px solid var(--border-md, rgba(0,0,0,.11));
  background: var(--bg, #fff); color: var(--text-2, #6B6B6B);
  font-size: .77rem; font-weight: 600;
  display: grid; place-items: center; cursor: pointer;
  transition: all .13s;
  font-family: var(--font-sans, -apple-system, sans-serif);
}
.cup-pg-btn:hover:not(:disabled) { border-color: #1B3A6B; color: #1B3A6B; background: rgba(27,58,107,.07); }
.cup-pg-btn:disabled { opacity: .35; cursor: not-allowed; }
.cup-pg-btn.active   { background: #1B3A6B; border-color: #1B3A6B; color: #fff; }
.cup-pg-ellipsis { width: 28px; height: 28px; display: grid; place-items: center; font-size: .77rem; color: var(--text-3, #B4B4B4); }

@media(max-width: 480px) {
  .cup-pagination { justify-content: center; }
  .cup-pag-info   { width: 100%; text-align: center; }
}
`;

/* ── ICONS ── */
const IcoSearch = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>;
const IcoTicket = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v2z" /></svg>;
const IcoEye = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>;
const IcoQr = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="3" height="3" /><rect x="18" y="14" width="3" height="3" /><rect x="14" y="18" width="3" height="3" /><rect x="18" y="18" width="3" height="3" /></svg>;
const IcoPen = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>;
const IcoLink = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" /></svg>;
const IcoChevL = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="15 18 9 12 15 6" /></svg>;
const IcoChevR = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6" /></svg>;
const IcoChevsL = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="11 17 6 12 11 7" /><polyline points="18 17 13 12 18 7" /></svg>;
const IcoChevsR = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="13 17 18 12 13 7" /><polyline points="6 17 11 12 6 7" /></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
════════════════════════════════════════════════════════ */
const Cupons = () => {

  /* inject CSS once */
  useEffect(() => {
    const id = "cup-styles";
    if (!document.getElementById(id)) {
      const el = document.createElement("style");
      el.id = id; el.textContent = CUP_CSS;
      document.head.appendChild(el);
    }
  }, []);

  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  let { business_code } = useParams();
  let user = JSON.parse(localStorage.getItem('user'));
  let token = localStorage.getItem('x-access-token');

  const [cupons, setCupons] = useState([]);
  const [groups, setGroups] = useState([]);
  const [combos, setCombos] = useState([]);
  const [categories, setCategories] = useState([]);
  const [eventHandler, setEventHandler] = useState(false);
  const [showQrModal, setShowQrModal] = useState(false);
  const [detailModal, setShowDetailModal] = useState(false);
  const [selectedCupon, setSelectedCupon] = useState(0);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [codeGenerated, setCodeGenerated] = useState("");

  const getCuponsByBusiness = async () => {
    try {
      let res = await CouponPosFetchAPI.getCuponsByBusiness(user.business.id, token);
      setCupons(res.data.data);
    } catch (err) { setCupons([]); }
  };

  const generateCuponCode = async (cupon_prefix) => {
    try {
      const response = await CouponPosFetchAPI.generateCuponCode(cupon_prefix, 13, 1, token);
      setSelectedCupon(response.data.data[0]);
      setShowQrModal(true);
    } catch (err) {
      ErrorAlert("Error al generar el código del cupón", "Por favor, inténtalo de nuevo más tarde.");
    }
  };

  const getGroups = async () => {
    try {
      let res = await GroupsFechtAPI.getGroupsByBusiness(user.business.id, token);
      console.log(res.data);
      setGroups(res.data.data);
    } catch (err) { setGroups([]); }
  };

  const getCombos = async () => {
    try {
      let res = await CombosFetchAPI.getCombosByBusiness(user.business.id, token);
      setCombos(res.data.combos);
    } catch (err) { setCombos([]); }
  };

  const getCategories = async () => {
    try {
      let res = await CategoriesDashFetchAPI.getCategoriesByBusiness(user.business.id, token);
      setCategories(res.data.data);
    } catch (err) { setCategories([]); }
  };

  useEffect(() => {
    getCombos();
    getGroups();
    getCuponsByBusiness();
    getCategories();
  }, []);

  useEffect(() => {
    if (eventHandler === 1) { getCuponsByBusiness(); }
    setEventHandler(0);
  }, [eventHandler]);
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  /* ── UI: búsqueda + paginación ── */
  const [search, setSearch] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const filtered = cupons.filter(c => {
    const q = search.toLowerCase();
    return !q || c.name?.toLowerCase().includes(q) || c.description?.toLowerCase().includes(q);
  });

  useEffect(() => { setCurrentPage(1); }, [search, pageSize]);

  const totalItems = filtered.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const safePage = Math.min(currentPage, totalPages);
  const paginated = filtered.slice((safePage - 1) * pageSize, safePage * pageSize);

  const pageNumbers = (() => {
    if (totalPages <= 5) return Array.from({ length: totalPages }, (_, i) => i + 1);
    if (safePage <= 3) return [1, 2, 3, 4, '…', totalPages];
    if (safePage >= totalPages - 2) return [1, '…', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    return [1, '…', safePage - 1, safePage, safePage + 1, '…', totalPages];
  })();

  /* ══════════════════════════════════
     RENDER
  ══════════════════════════════════ */
  return (
    <>
      <AppShell route="cupons">
        <MainContent>
          <div className="cup-page">

            {/* ── BANNER ── */}
            <div className="cup-banner">
              <div>
                <p className="cup-banner-eyebrow">Gestión</p>
                <h1 className="cup-banner-title">Cupones</h1>
                <p className="cup-banner-sub">Gestión y creación de cupones</p>
              </div>
              {/* Modal crear — lógica original intacta */}
              <ModalCreateCupon
                user={user}
                token={token}
                groups={groups}
                combos={combos}
                setEventHandler={setEventHandler}
              />
            </div>

            {/* ── TOOLBAR ── */}
            <div className="cup-toolbar">
              <div className="cup-toolbar-left">
                <span className="cup-section-title">
                  <IcoTicket /> Listado de cupones
                  <span className="cup-count">{totalItems}</span>
                </span>
              </div>
              <div className="cup-search">
                <IcoSearch />
                <input
                  type="text"
                  placeholder="Buscar cupón..."
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                />
              </div>
            </div>

            {/* ── GRID DE CARDS ── */}
            <div className="cup-grid">
              {totalItems === 0 ? (
                <div className="cup-empty">
                  <div className="cup-empty-icon">🎫</div>
                  <p className="cup-empty-title">
                    {search ? 'Sin resultados' : 'Sin cupones creados'}
                  </p>
                  <p className="cup-empty-sub">
                    {search
                      ? `No hay cupones que coincidan con "${search}".`
                      : 'Crea tu primer cupón con el botón de arriba.'}
                  </p>
                </div>
              ) : paginated.map((cupon, index) => (
                <div
                  className="cup-card"
                  key={cupon.id || index}
                  style={{ animationDelay: `${index * 0.04}s` }}
                >
                  {/* card body */}
                  <div className="cup-card-inner">
                    <img
                      className="cup-thumb"
                      loading="lazy"
                      src={cupon.img
                        ? buildCloudinaryImageUrl({ url: cupon.img, width: 300, quality: "auto", type: "image" })
                        : defaultImage}
                      alt={cupon.name}
                    />
                    <div className="cup-card-body">
                      <div className="cup-card-name" title={cupon.name}>{cupon.name}</div>
                      <div className="cup-card-desc">{cupon.description}</div>
                    </div>
                  </div>

                  {/* acciones — lógica original intacta */}
                  <div className="cup-card-footer">
                    <button
                      className="cup-btn"
                      title="Ver detalles"
                      onClick={() => { setShowDetailModal(true); setSelectedCupon(cupon.id); }}
                    >
                      <IcoEye />
                    </button>
                    <button
                      className="cup-btn"
                      title="Ver QR"
                      onClick={() => { setShowQrModal(true); setSelectedCupon(cupon.code_prefix); }}
                    >
                      <IcoQr />
                    </button>
                    <button
                      className="cup-btn"
                      title="Editar"
                      onClick={() => { setShowUpdateModal(true); setSelectedCupon(cupon.id); }}
                    >
                      <IcoPen />
                    </button>
                    <button
                      className="cup-btn cup-btn-danger"
                      title="Generar código"
                      onClick={() => generateCuponCode(cupon.code_prefix)}
                    >
                      <IcoLink />
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* ── PAGINACIÓN ── */}
            {totalItems > 0 && (
              <div className="cup-pagination">
                <div className="cup-pag-info">
                  Mostrando <span>{(safePage - 1) * pageSize + 1}–{Math.min(safePage * pageSize, totalItems)}</span> de <span>{totalItems}</span> cupones
                </div>
                <div className="cup-pag-right">
                  <div className="cup-pag-size">
                    Mostrar
                    <select value={pageSize} onChange={e => { setPageSize(Number(e.target.value)); setCurrentPage(1); }}>
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                    </select>
                    por página
                  </div>
                  <div className="cup-pag-controls">
                    <button className="cup-pg-btn" onClick={() => setCurrentPage(1)} disabled={safePage === 1}><IcoChevsL /></button>
                    <button className="cup-pg-btn" onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={safePage === 1}><IcoChevL /></button>
                    {pageNumbers.map((pg, i) =>
                      pg === '…'
                        ? <span className="cup-pg-ellipsis" key={`e${i}`}>…</span>
                        : <button key={pg} className={`cup-pg-btn${safePage === pg ? ' active' : ''}`} onClick={() => setCurrentPage(pg)}>{pg}</button>
                    )}
                    <button className="cup-pg-btn" onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={safePage === totalPages}><IcoChevR /></button>
                    <button className="cup-pg-btn" onClick={() => setCurrentPage(totalPages)} disabled={safePage === totalPages}><IcoChevsR /></button>
                  </div>
                </div>
              </div>
            )}

            {/* ── MODALES ORIGINALES ── */}
            <QRCodeModal
              textToEncode={selectedCupon}
              showModal={showQrModal}
              setShowModal={setShowQrModal}
            />
            <CuponDetailModal
              cupon={selectedCupon}
              showModal={detailModal}
              setShowModal={setShowDetailModal}
              groups={groups}
              combos={combos}
              categories={categories}
              user={user}
            />
            <ModalUpdateCupon
              cupon={selectedCupon}
              token={token}
              setEventHandler={setEventHandler}
              showModal={showUpdateModal}
              setShowModal={setShowUpdateModal}
            />

          </div>
          <Footer />
        </MainContent>
      </AppShell>

    </>
  );
};

export default Cupons;